export const TYPOGRAPHY_ALIGN = {
    inherit: ['[text-align:inherit]'],
    left: ['text-left'],
    center: ['text-center'],
    right: ['text-right'],
    justify: ['text-justify'],
};
